import { useTranslation } from "react-i18next";

const transactionCurrencyOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "hkd",
      title: t("options.currency.hkd"),
      value: "HKD",
    },
    {
      key: "usd",
      title: t("options.currency.usd"),
      value: "USD",
    },
    {
      key: "eur",
      title: t("options.currency.eur"),
      value: "EUR",
    },
    {
      key: "jpy",
      title: t("options.currency.jpy"),
      value: "JPY",
    },
    {
      key: "gbp",
      title: t("options.currency.gbp"),
      value: "GBP",
    },
    {
      key: "cad",
      title: t("options.currency.cad"),
      value: "CAD",
    },
    {
      key: "aud",
      title: t("options.currency.aud"),
      value: "AUD",
    },
    {
      key: "thb",
      title: t("options.currency.thb"),
      value: "THB",
    },
    {
      key: "vnd",
      title: t("options.currency.vnd"),
      value: "VND",
    },
    {
      key: "sgd",
      title: t("options.currency.sgd"),
      value: "SGD",
    },
    {
      key: "twd",
      title: t("options.currency.twd"),
      value: "TWD",
    },
    {
      key: "krw",
      title: t("options.currency.krw"),
      value: "KRW",
    },
    {
      key: "idr",
      title: t("options.currency.idr"),
      value: "IDR",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  if (typeof list === "function") {
    return options.filter(list);
  }
  return [];
};

export default transactionCurrencyOptions;
